<style lang="scss">
.page-inner {
    max-width: 1200px;
    margin: 0 auto;
}

.welcome-card {
    border-radius: 8px;

    :deep(.ant-card-head) {
        border-bottom: 1px solid #f0f0f0;
        padding: 0 16px;
        min-height: 48px;
    }

    :deep(.ant-card-body) {
        padding: 24px;
    }
}

.welcome-title {
    font-size: 20px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.88);
    margin-bottom: 8px;
}

.welcome-desc {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
}

@media screen and (max-width: 768px) {
    .welcome-card :deep(.ant-card-body) {
        padding: 16px;
    }

    .welcome-title {
        font-size: 16px;
    }
}
</style>

<template>
    <a-layout style="min-height: 100vh;">
        <AdminHead />
        <a-layout>
            <a-layout-content class="page-content" style="padding: 24px; background: #f5f7fa;">
                <div class="page-inner">
                    <a-card class="welcome-card" :bordered="false">
                        <div class="welcome-title">管理后台控制台</div>
                        <div class="welcome-desc">欢迎使用管理后台，请从左侧菜单选择操作</div>
                    </a-card>
                </div>
            </a-layout-content>
        </a-layout>
    </a-layout>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AdminHead from '@/components/AdminHead.vue';
export default defineComponent({
    components: {
        AdminHead,
    },
});
</script>
